import React, { useEffect, useState } from "react";

const ChartTable = ({ alertTypeData }) => {
  const [totals, setTotals] = useState({});

  const getAlertTotals = (data = []) =>
    data.reduce(
      (acc, item) => {
        acc.total_alerts_count += item.total_alerts_count || 0;
        acc.new_alerts_count += item.new_alerts_count || 0;
        acc.assigned_alerts_count += item.assigned_alerts_count || 0;
        acc.closed_alerts_count += item.closed_alerts_count || 0;
        return acc;
      },
      {
        total_alerts_count: 0,
        new_alerts_count: 0,
        assigned_alerts_count: 0,
        closed_alerts_count: 0,
      }
    );

  useEffect(() => {
    if (alertTypeData?.length > 0) {
      setTotals(getAlertTotals(alertTypeData));
    }
  }, [alertTypeData]);

  return (
    <div className=" border border-1 border-black" style={{ padding: "8px" }}>
      <table className="" style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr className="f3 fs-sm-12 fs-md-14 fs-lg-14 fs-xl-14 fs-xxl-16 mx-2 text-muted fw-light">
            <th>Name</th>
            <th>Total Alerts</th>
            <th>New Alerts</th>
            <th>Assigned Alerts</th>
            <th>Closed Alerts</th>
          </tr>
        </thead>

        <tbody className="">
          {alertTypeData?.map((row, index) => (
            <tr
              className="f2 fs-sm-12 fs-md-14 fs-lg-14 fs-xl-14 fs-xxl-16 mx-2 text-muted first-data-row fw-light"
              key={index}
            >
              <td className="">{row?.alert_type_name}</td>
              <td className="text-center">{row?.total_alerts_count}</td>
              <td className="text-center">{row?.new_alerts_count}</td>
              <td className="text-center">{row?.assigned_alerts_count}</td>
              <td className="text-center">{row?.closed_alerts_count}</td>
            </tr>
          ))}
        </tbody>

        {/* TOTAL ROW */}
        <tfoot>
          <tr className="f2 fs-sm-12 fs-md-14 fs-lg-14 fs-xl-14 fs-xxl-16 mx-2 text-muted fw-light total-row">
            <td>Total</td>
            <td className="text-center">{totals?.total_alerts_count}</td>
            <td className="text-center">{totals?.new_alerts_count}</td>
            <td className="text-center">{totals?.assigned_alerts_count}</td>
            <td className="text-center">{totals?.closed_alerts_count}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default ChartTable;
